export const LIPA_BIDHAA_BANNER_CONFIG = {
  otp_session_expired: {
    variant: "warning",
    title: "Session Expired",
    message: "You were inactive for too long. Please start a new payment.",
  },
};
